export const CONSENT = {
  GET_ALL_CONSENTS: 'CONSENT/GET_ALL_CONSENTS',
  UPDATE_CONSENT: 'CONSENT/UPDATE_CONSENT',
  SET_IS_FETCHING_STATUS: 'CONSENT/SET_IS_FETCHING_STATUS',
  SET_IS_UPDATING_STATUS: 'CONSENT/SET_IS_UPDATING_STATUS',
} as const;
